import classNames from "classnames";
import React from "react";
import { Icon, IconName } from "../../../components";
import styles from "./portal_button.module.css";

interface PortalButtonProps {
  children?: string;
  appearance?: "default" | "text" | "danger" | "outlined";
  onClick?: () => void;
  leftIconName?: IconName;
  disabled?: boolean;
}

export function PortalButton({
  children,
  appearance = "default",
  leftIconName,
  onClick,
  disabled,
}: PortalButtonProps) {
  let appearanceClass = styles.default;
  if (appearance === "text") {
    appearanceClass = styles.text;
  } else if (appearance === "danger") {
    appearanceClass = styles.danger;
  } else if (appearance === "outlined") {
    appearanceClass = styles.outlined;
  }

  const btnClass = classNames(
    styles.button,
    appearanceClass,
    disabled && styles.disabled
  );

  return (
    <button className={btnClass} onClick={onClick} disabled={disabled}>
      {leftIconName && <Icon name={leftIconName} className={styles.icon} />}
      {children}
    </button>
  );
}
